import type { AxiosRequestConfig } from 'axios'

import { httpInstance } from './http.instance'

async function getRequest<T>(url: string, config?: AxiosRequestConfig) {
  try {
    return await httpInstance.get<T>(url, { ...config })
  }
  catch (e: any) {
    // console.log(e,   'Error in getRequest');
    throw e.response?.data
  }
}

async function postRequest<T, K>(url: string, data: K, config?: AxiosRequestConfig) {
  try {
    return await httpInstance.post<T>(url, data, config)
  }
  catch (e: any) {
    throw e.response?.data
  }
}

async function putRequest<T, K>(url: string, data: K, _config?: AxiosRequestConfig) {
  try {
    return await httpInstance.put<T>(url, data)
  }
  catch (e: any) {
    throw e.response?.data
  }
}

async function patchRequest<T, K>(url: string, data: K, _config?: AxiosRequestConfig) {
  try {
    return await httpInstance.patch<T>(url, data)
  }
  catch (e: any) {
    throw e.response?.data
  }
}

async function deleteRequest<T>(url: string) {
  try {
    return await httpInstance<T>({ method: 'DELETE', url })
  }
  catch (e: any) {
    throw e.response?.data
  }
}

export { deleteRequest, getRequest, patchRequest, postRequest, putRequest }
